import { ChangeDetectorRef, Injectable, Provider, TemplateRef, Type } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { WixChangeDetectionHelper } from '../../../common/helpers/wix-change-detection.helper';
import { ShadowStyleLoaderService } from '../shadow.style.loader/shadow.style.loader.service';
import { isEmptyArray } from '../../utils/object.extensions';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  public static modalConfiguration: MatDialogConfig = {
    width: '600px',
  };

  constructor(
    private dialog: MatDialog,
    private shadowStyleLoader: ShadowStyleLoaderService
  ) {}

  public show<T>(config: {
    component: Type<T> | TemplateRef<T>;
    data?: any;
    providers?: Provider[];
    panelClass?: string | string[];
    backdropClass?: string;
    disableClose?: boolean;
  }) {
    let dialogRef = this.dialog.open(
      config.component,
      Object.assign({}, ModalService.modalConfiguration, {
        data: config.data,
        panelClass: config.panelClass,
        backdropClass: config.backdropClass,
        disableClose: config.disableClose,
      })
    );
    return dialogRef;
  }

  public injectStyle(
    selector: string,
    styles: string[] = [],
    onLoad: () => void,
    cdRef?: ChangeDetectorRef,
    componentId?: string
  ): void {
    let all = document.querySelectorAll(selector);
    if (isEmptyArray(all)) {
      let shadowRoot = (
        document.getElementById('imgoingcalendar-wrapper') ||
        document.getElementById('imgoingcalendar-wrapper-wix')
      )?.querySelector('app-root')?.shadowRoot;

      shadowRoot = shadowRoot || document.querySelector('app-root').shadowRoot;

      all = shadowRoot.querySelectorAll(selector);

      if (isEmptyArray(all)) {
        console.warn('No element found with the selector', selector);
        return;
      }
    }

    let shadowRoot = Array.from(all)?.last()?.shadowRoot;

    if (!Array.from(all)?.length || !Array.from(all)?.last() || !shadowRoot) {
      const ele = document.querySelector(selector);
      if (ele) {
        shadowRoot = ele.shadowRoot;
      }
    }

    this.shadowStyleLoader.injectBaseStyles(shadowRoot, () => {
      onLoad && onLoad();

      if (cdRef && componentId) {
        WixChangeDetectionHelper.setupWixChangeDetection(cdRef, componentId, {
          initialDelay: 200,
          pollInterval: 100,
          maxPolls: 100,
        });
        console.log(`[MODAL SERVICE] Auto-applied Wix fixes to ${componentId}`);
      }
    });

    if (styles.length) {
      styles.forEach((style) => {
        this.shadowStyleLoader.appendStylesheet(shadowRoot, style);
      });
    }
  }

  public showWithWixFix<T>(config: {
    component: Type<T> | TemplateRef<T>;
    data?: any;
    providers?: Provider[];
    panelClass?: string | string[];
    backdropClass?: string;
    disableClose?: boolean;
    componentId?: string;
  }): MatDialogRef<T> {
    const dialogRef = this.dialog.open(
      config.component,
      Object.assign({}, ModalService.modalConfiguration, {
        data: config.data,
        panelClass: config.panelClass,
        backdropClass: config.backdropClass,
        disableClose: config.disableClose,
      })
    );

    if (WixChangeDetectionHelper.isWixEnvironment()) {
      dialogRef.afterOpened().subscribe(() => {
        console.log(
          `[MODAL SERVICE] Auto-applying Wix fixes to ${config.componentId || 'modal'}`
        );

        setTimeout(() => {
          if (window['IMGoing']?.forceChangeDetection) {
            window['IMGoing'].forceChangeDetection();
            console.log(
              `[MODAL SERVICE] Global force detection applied to ${config.componentId || 'modal'}`
            );
          }
        }, 100);
      });
    }

    return dialogRef;
  }
}
